import type { KeyboardEvent } from 'react'
import { Avatar } from '@/common/ui/Avatar'
import { Button } from '@/common/ui/Form/Button'
import { Icon } from '@/common/ui/Icon'
import { Modal } from '@/common/ui/Modal'
import { AvatarCropUpload } from '@/common/ui/AvatarCropUpload'
import { ORG_LOGO_MODAL_TOGGLE_ID, setOrgLogoModalOpen, useOrgLogoUpload } from '../model/orgLogoUploadModel'

export type OrgLogoUploadBlockProps = {
    orgId: string
    orgName: string
    logoUrl?: string | null
    disabled?: boolean
    orgLoading?: boolean
}

export const OrgLogoUploadBlock = ({ orgId, orgName, logoUrl, disabled, orgLoading }: OrgLogoUploadBlockProps) => {
    const { seedFile, onSeedFileConsumed, isUploadPending, handleExport } = useOrgLogoUpload(orgId)

    const hasLogo = Boolean(logoUrl)
    const isControlDisabled = Boolean(disabled || orgLoading)

    const handleOpenModal = () => {
        if (isControlDisabled) {
            return
        }
        setOrgLogoModalOpen(true)
    }

    const handleKeyDownButton = (event: KeyboardEvent<HTMLButtonElement>) => {
        if (isControlDisabled) {
            return
        }
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            setOrgLogoModalOpen(true)
        }
    }

    const actionLabel = hasLogo ? 'Изменить логотип' : 'Добавить логотип'

    return (
        <>
            <div className='grid-col-2 flex mt-[0.5rem] items-center'>
                <Avatar size='md' placeholder={orgName} image={logoUrl ?? undefined} />
                <Button
                    type='button'
                    color='accent'
                    variant='ghost'
                    size='lg'
                    disabled={isControlDisabled}
                    aria-label={hasLogo ? 'Изменить логотип организации' : 'Добавить логотип организации'}
                    onClick={handleOpenModal}
                    onKeyDown={handleKeyDownButton}
                >
                    {actionLabel}
                    <Icon name='import' size='md' />
                </Button>
            </div>

            <Modal id={ORG_LOGO_MODAL_TOGGLE_ID} modalClassName='md:max-w-[512px] md:min-w-[512px]'>
                <h3 className='mb-4 text-lg font-bold'>Логотип организации</h3>
                <AvatarCropUpload
                    shape='circle'
                    outputSize={{ width: 512, height: 512 }}
                    disabled={isUploadPending}
                    seedFile={seedFile}
                    onSeedFileConsumed={onSeedFileConsumed}
                    onExport={handleExport}
                    exportFileName='org-logo'
                />
            </Modal>
        </>
    )
}
